import RootStore from "store/rootStore";

export const pastePolygonsWithoutConfirm = (store: RootStore) => {
    const {
        labelerSegmentationUiStore: {
            setPolygons,
            setPastePolygons,
            getSavedPolygons,
        },
        labelerSegmentationStore: {
            deleteAllSegments,
            changeMotif
        }
    } = store;

    const savedPolygons = getSavedPolygons();
    changeMotif(null, false);
    deleteAllSegments();
    setPolygons(savedPolygons.polygons);
    setPastePolygons(true);
}

const pastePolygonsHandler = (store: RootStore) => {
    if (store.labelerSegmentationUiStore.imageLoadError) {
        return;
    }

    const {
        labelerSegmentationUiStore: {
            polygons,
            hasSavedPolygons,
            setOpenAlertDialog,
            setAlertDialogText,
            setAlertDialogCallback
        },
        labelerSegmentationStore: {
            images,
            numImage,
        }
    } = store;

    if (!hasSavedPolygons())
        return

    const haveMotif = images[Number(numImage)].motif !== null;

    if (polygons.length > 0 || haveMotif ) {
        setAlertDialogText("Êtes-vous sur de vouloir remplacer les labellisations existantes ?")
        setAlertDialogCallback(() => { pastePolygonsWithoutConfirm(store) });
        setOpenAlertDialog(true);
    } else {
        pastePolygonsWithoutConfirm(store)
    }
}

export default pastePolygonsHandler
